import { render, staticRenderFns } from "./readyExamine.vue?vue&type=template&id=71d178cb"
import script from "./readyExamine.vue?vue&type=script&lang=js"
export * from "./readyExamine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports